/**
 * Bank-line allocation copy, base (legal) dialect. The en catalog is complete
 * by definition - its object type IS the key schema every other locale
 * overrides.
 *
 * Sourced from the Bill bank-statement surfaces (`ProposalSummary`, the
 * invoice / credit-note match cells) and the admin classification drawer,
 * which all explain WHY a document was suggested for a statement line. The
 * scorer persists only the identifier token that corroborated the match
 * (`SuggestedAllocationLeg['reason']` in `@packages/types`: `'invoice number'`,
 * `"client's name"`, ...); the sentence around it is copy, so it lives here,
 * once, rather than being composed at each render site.
 */
export const allocation = {
    /**
     * Why a document match was suggested, one whole sentence per identifier the
     * scorer can record. Looked up by token through `describeAllocationMatchReason`
     * (`src/match-reason.ts`); a render site never composes these from the
     * token itself.
     */
    matchReason: {
        /** Token `'invoice number'`. */
        invoiceNumber: 'Exact amount and invoice number in the statement line',
        /** Token `'payment reference'`. */
        paymentReference: 'Exact amount and payment reference in the statement line',
        /** Token `'reference'`. */
        reference: 'Exact amount and reference in the statement line',
        /** Token `"client's name"`. */
        clientName: "Exact amount and client's name in the statement line",
        /** Token `"supplier's name"`. */
        supplierName: "Exact amount and supplier's name in the statement line",
        /** Token `'credit note number'`. */
        creditNoteNumber: 'Exact amount and credit note number in the statement line',
        /** Token `'exact amount'`: the outstanding amount alone matched, with nothing in the line description to corroborate it. */
        exactAmount: 'Exact outstanding amount matches the statement line',
    },
};
